



















































































import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {requiredRule} from "@/utils/validators";
import {REGIONS} from "@/utils/utils";
import {gMutate, gQuery} from "@/services/graphql"
import {CreateProfile, CreateProfileVariables} from "@dynamoit/shared/generated/CreateProfile"
import {ProfilesGQL} from '@dynamoit/shared/src/queries/ProfilesGQL'
import {Profile} from "@dynamoit/shared/generated/GraphQLTypes"
import {AllProfiles} from "@dynamoit/shared/generated/AllProfiles";
import {DeleteProfile, DeleteProfileVariables} from "@dynamoit/shared/generated/DeleteProfile";

@Component
export default class EditProfile extends Vue {

    @Prop()
    public id?: string

    private profile: Profile = {
        id: '',
        userId: '',
        profileName: '',
        description: '',
        accessKeyId: '',
        secretAccessKey: '',
        region: ''
    }

    private loading = false
    private saving = false
    private deleting = false
    private requiredRule = requiredRule

    private get regions() {
        return REGIONS.map(_ => ({
            ..._,
            title: `${_.name} - ${_.title}`
        })).sort((a, b) => a.name.localeCompare(b.name))
    }

    @Watch('id', {immediate: true})
    private async onIdChanged() {
        if (this.id) {
            try {
                this.loading = true
                const result = await gQuery<AllProfiles>(ProfilesGQL.ALL_PROFILES);
                this.profile = {
                    ...this.profile,
                    ...result.data.profiles.find(_ => _.id === this.id) || {}
                }
            } finally {
                this.loading = false
            }
        }
    }


    private async onSaveClick() {
        if ((this.$refs.form as any).validate()) {
            try {
                this.saving = true
                await gMutate<CreateProfile, CreateProfileVariables>(ProfilesGQL.CREATE_PROFILE, {
                    profileName: this.profile.profileName,
                    description: this.profile.description || undefined,
                    region: this.profile.region,
                    accessKeyId: this.profile.accessKeyId,
                    secretAccessKey: this.profile.secretAccessKey
                })
                this.$router.push({name: 'home'})
            } finally {
                this.saving = false
            }
        }
    }

    private async onDeleteClick() {
        if (this.id) {
            try {
                this.deleting = true
                await gMutate<DeleteProfile, DeleteProfileVariables>(ProfilesGQL.DELETE_PROFILE, {
                    profileId: this.id
                })
                await this.$router.push({name: 'home'})
            } finally {
                this.deleting = false
            }
        }
    }

}
